import { render, staticRenderFns } from "./categoryData.vue?vue&type=template&id=0de420fa&scoped=true&"
import script from "./categoryData.vue?vue&type=script&lang=js&"
export * from "./categoryData.vue?vue&type=script&lang=js&"
import style0 from "./categoryData.vue?vue&type=style&index=0&id=0de420fa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de420fa",
  null
  
)

export default component.exports